






















































import Vue from 'vue';

import { breakpointsMixin } from '@/mixins/breakpoints';
import { iconsMixin } from '@/mixins/icons';

import DropdownOption from '@/models/misc/DropdownOption';

import hazmatService from '@/services/HazmatService';

export default Vue.extend<any, any, any, any>({
    name: 'truck-quote-service-information',
    mixins: [breakpointsMixin, iconsMixin],
    props: {
        value: {
            type: Object,
            required: true
        },
        showError: {
            type: Boolean,
            default: false
        },
        missingFields: {
            type: Array,
            default: () => []
        },
        equipmentTypesDdl: {
            type: Array as () => DropdownOption[],
            default: () => []
        }
    },
    data() {
        return {
            hazmatClasses: [] as DropdownOption[],
            selectedHazardousClass: null,
        };
    },
    computed: {
        serviceInfo: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        pickupMinDate(): string {
            return new Date().toISOString().substr(0, 10);
        },
        pickupMaxDate(): string {
            const maxDate = new Date();
            maxDate.setFullYear(maxDate.getFullYear() + 1);
            return maxDate.toISOString().substr(0, 10);
        },
        deliveryMinDate(): string {
            return this.serviceInfo.pickupDate || new Date().toISOString().substr(0, 10);
        },
        deliveryMaxDate(): string {
            const maxDate = new Date();
            maxDate.setFullYear(maxDate.getFullYear() + 1);
            return maxDate.toISOString().substr(0, 10);
        }
    },
    created() {
        hazmatService.list().then((x) => {
            this.hazmatClasses = x.map((p) => this.mapHazmatClass(p));
        });
    },
    methods: {
        pickupDateChanged(date) {
            if (this.serviceInfo.deliveryDate && date > this.serviceInfo.deliveryDate) {
                this.serviceInfo.deliveryDate = null;
            }
            this.$emit('pickup-date-changed', date);
        },
        deliveryDateChanged(date) {
            this.$emit('delivery-date-changed', date);
        },
        mapHazmatClass(obj) {
            return new DropdownOption(obj.name, obj.code);
        },
        onHazardousClassChange(value) {
            if (value) {
                const validOption = this.hazmatClasses.find(
                    (option) => option.value === value.value
                );
                if (!validOption) {
                    this.selectedHazardousClass = null;
                } else {
                    this.serviceInfo.hazardousClass = value.value;
                }
            } else {
                this.serviceInfo.hazardousClass = '';
            }
        },
        validateBlock(): boolean {
            const missingFields: string[] = [];
            const info = this.value;
            if (!info.pickupDate) missingFields.push('Pickup Date');
            if (!info.deliveryDate) missingFields.push('Dropoff Date');

            this.$emit('update:missingFields', missingFields);
            this.$emit('update:showError', missingFields.length > 0);
            return missingFields.length === 0;
        }
    }
});
